module.exports = __webpack_public_path__ + "static/img/index-01.faa86aa0.png";